import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    className: PropTypes.string,
    disabled: PropTypes.bool,
    expanded: PropTypes.bool,
    onClick: PropTypes.func,
    ariaText: PropTypes.string,
    ariaDescribedBy: PropTypes.string,
    ariaControls: PropTypes.string,
    expandedImg: PropTypes.string, // path to img, overrides expandedIcon
    collapsedImg: PropTypes.string, // path to img, overrides collapsedImg
    expandedIcon: PropTypes.string, //font awesome icon class
    collapsedIcon:PropTypes.string,  //font awesome icon class
    controlTitle: PropTypes.string,
    children: PropTypes.node,
    useRightChildren: PropTypes.bool,
    preventGlyphColor: PropTypes.bool,
};

const defaultProps = {
    className: '',
    disabled: false,
    expanded: false,
    ariaText: '',
    ariaDescribedBy: '',
    ariaControls: '',
    onClick: () => { return; },
    expandedImg: '',
    collapsedImg: '',
    expandedIcon: 'fa-caret-down',
    collapsedIcon: 'fa-caret-right',
    controlTitle: '',
    children: null,
    useRightChildren: false,
    preventGlyphColor: false,
};

function ExpansionButton({ className, disabled, expanded, onClick, ariaText, ariaDescribedBy, ariaControls, expandedImg, collapsedImg, expandedIcon, collapsedIcon, controlTitle, useRightChildren, preventGlyphColor, children }) {
    function _onClick(e) {
        e.stopPropagation(); // FIXME prevents odd page refresh behavior (PublishActivityModal)
        e.preventDefault(); // FIXME

        if (disabled) {
            return;
        }

        onClick();
    }
    let expandedElem;
    let collapsedElem;
    if (expandedImg) {
        expandedElem = <img src={expandedImg} aria-hidden="true" />;
    }
    else {
        expandedElem = <span className={`fa ${expandedIcon}`} aria-hidden="true" />;
    }

    if (collapsedImg) {
        collapsedElem = <img src={collapsedImg} aria-hidden="true" />;
    }
    else {
        collapsedElem = <span className={`fa ${collapsedIcon}`} aria-hidden="true" />;
    }

    let extraButtonProps = {};
    if (!!controlTitle) {
        extraButtonProps.title = controlTitle;
    }
    if (ariaDescribedBy) {
        extraButtonProps['aria-describedby'] = ariaDescribedBy;
    }
    if (ariaControls) {
        extraButtonProps['aria-controls'] = ariaControls;
    }

    return (
        <button
            className={`exp-button bare-text-button ${!preventGlyphColor ? 'glyph' : ''} ${className}`}
            aria-expanded={expanded}
            disabled={disabled}
            onClick={_onClick}
            {...extraButtonProps}
        >
            {(!!children && !useRightChildren) &&
                <span className="margin-right-sm">{children}</span>
            }
            {(expanded) ?
                expandedElem
                :
                collapsedElem
            }
            {(!!children && useRightChildren) &&
                <span className="margin-left-sm">{children}</span>
            }
            { ariaText ? 
            <span className="sr-only">{ariaText}</span>
            : null }
        </button>
    );
}

ExpansionButton.propTypes = propTypes;
ExpansionButton.defaultProps = defaultProps;

export default ExpansionButton;